<template>
  <div>
    <el-row>
      <el-col>
        <h1>Clone PEAs</h1>
        <status-dropdown v-model="status" :inputModel="status"></status-dropdown>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      </el-col>
    </el-row>
    <el-table :data="tableData" @current-change="selectRow" class="clonePEAsTable" v-loading="tableLoading">
      <el-table-column prop="id" label="PEA No." width="140"></el-table-column>
      <el-table-column prop="peaName" label="Name" width="220"></el-table-column>
      <el-table-column prop="peaStatus" label="Status" width="160">
        <template slot-scope="scope">
          <status-icon :statusId="scope.row.peaStatusId"></status-icon> {{ scope.row.peaStatus }}
        </template>
      </el-table-column>
      <el-table-column prop="createdDate" label="Created" width="150">
        <template slot-scope="scope">
          {{ displayDate(scope.row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="lastUpdatedDate" label="Updated" width="150">
        <template slot-scope="scope">
          {{ displayDate(scope.row.lastUpdatedDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="netExpenditure" label="Cost" width="200">
        <template slot-scope="scope">
          ${{ currencyFormat(scope.row.netExpenditure) }}
        </template>
      </el-table-column>
      <el-table-column prop="capitalBudget" label="Capital Budget ID" width="130"></el-table-column>
      <el-table-column prop="peaDivision" label="Division" width="152"></el-table-column>
      <el-table-column prop="peaDepartments" label="Departments" width="180">
        <template slot-scope="scope">
          <ul>
            <li v-for="department in scope.row.peaDepartments" v-bind:key="department.id">{{ department.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="Reason" width="150"></el-table-column>
      <el-table-column prop="urgency" label="Emergency" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.urgency">Yes</span>
          <span v-else>No</span>
        </template>
      </el-table-column>
    </el-table>
    <br/>
    <el-pagination v-if="resultTotal > pageSize"
      @current-change="getPeas"
      :current-page.sync="page"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="resultTotal"
      background>
    </el-pagination>
  </div>
</template>

<script>
import router from '@/router'
import helperMethods from '@/components/utility/helperMethods.js'
import {statusList} from '@/components/utility/statusList.js'
import moment from 'moment'
export default {
  props: {
    statusId: 0
  },
  mixins: [statusList],
  data () {
    return {
      alertType: '',
      alertTitle: '',
      callInfo: '',
      tableData: null,
      page: 1,
      pageSize: 5,
      resultTotal: 0,
      status: parseInt(this.statusId),
      tableLoading: true
    }
  },
  computed: {
    filter: function () {
      if (this.status > 0) {
        return 'filter=status:' + this.status + '&'
      }
      return ''
    }
  },
  watch: {
    status: function () {
      router.push('/clonePEAs/status/' + this.status)
    }
  },
  methods: {
    getPeas: function () {
      this.tableLoading = true
      var call = '/myPEAs?' + this.filter + 'page=' + this.page + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.tableData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this, 'Error returning PEAs', reject.body, 'error', 30000, '')
      })
    },
    selectRow: function (row) {
      router.push('/clonedPEA/' + row.id)
    },
    displayDate: function (input) {
      return moment(input).format('MMM D, YYYY')
    },
    currencyFormat (number) {
      return helperMethods.formatMoney(number)
    }
  },
  mounted: function () {
    this.getPeas()
  }
}
</script>

<style scoped>
    ul {
      padding: 0;
      margin: 0;
      margin-left: 15px;
    }

    .el-select {
      width: auto;
      position: relative;
      top: 3px;
    }

    h1 {
      float: left;
      margin-right: 30px;
    }
</style>

<style>
  .clonePEAsTable tr:hover {
    cursor: pointer;
  }
</style>
